const Answer = require('./answer')

var CLASS_RADIO = 'is__radio'
var CLASS_STANDALONE = 'is__standalone'

var Question = function($el, test) {
  this.$el = $el
  this._test = test
  this.id = this._test.id + '.' + this.$el.data('id')

  this.counter = 0
  this.answers = []
  this.counters = {
    totalCorrect: 0,
    checked: {
      total: 0,
      correct: 0,
      wrong: 0,
    },
  }

  this.isCorrect = false

  this.isStandalone = $el.hasClass(CLASS_STANDALONE)
  this.isRadio = $el.hasClass(CLASS_RADIO)

  this.addAnswers()
}

Question.prototype.uncheckOtherThan = function(selectedAnswer) {
  this.answers
    .filter(answer => answer !== selectedAnswer)
    .filter(answer => answer.isChecked)
    .forEach(answer => answer.uncheck())
}

Question.prototype.init = function() {
  this.answers.forEach(answer => answer.init())
}

Question.prototype.addAnswers = function() {
  this.$el.find('.js__answer').each((_, el) => {
    this.answers.push(new Answer($(el), this))
  })
}

Question.prototype.lock = function() {
  this.answers.forEach(answer => answer.lock())
}

Question.prototype.reset = function() {
  this.counters.checked = {
    total: 0,
    correct: 0,
    wrong: 0,
  }
  this.isDone = false

  this.answers.forEach(answer => answer.reset())
}

Question.prototype.erase = function() {
  this.reset()

  // FIXME: switch to proper logux-compatible implementation
  window.application.state
    .syncTest
    .resetTest(this._test.revealId)
}

Question.prototype.check = function(isChecked, isCorrect) {
  if (isChecked) {
    this.counters.checked.total++
  } else {
    this.counters.checked.total--
  }

  if (isCorrect) {
    if (isChecked) {
      this.counters.checked.correct++
    } else {
      this.counters.checked.correct--
    }
  } else {
    if (isChecked) {
      this.counters.checked.wrong++
    } else {
      this.counters.checked.wrong--
    }
  }

  this.isCorrect = this.counters.checked.wrong === 0 &&
    this.counters.checked.correct === this.counters.totalCorrect
  this.isDone = this.counters.checked.total > 0

  this._test.check()
}

Question.prototype.isReadyForCheck = function() {
  return this.counters.checked.total > 0 &&
    this.counters.checked.total >= this.counters.totalCorrect
}

module.exports = Question
